import { postData } from 'src/api/http.service';
import {
  handleApiError,
  removeDataFromSessionStorage,
  setDataToSessionStorage,
} from 'src/utils/general.utils';
import { resetFileExplorerStore } from './fileExplorer.action';
import {
  ApiCallFailedAction,
  ApiCallInProgress,
  ApiCallSuccessAction,
  ResetUIState,
} from './uistate.action';

const headers = {
  'Content-type': 'application/json',
  'User-Agent': '',
  browserip: '',
};
const LoginManagementActionTypes = {
  OTP_CREATED_SUCCESS: 'OTP_CREATED_SUCCESS',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
};

// Plain actions *******************************************************
function OTPcreatedSuccessAction() {
  return {
    type: LoginManagementActionTypes.OTP_CREATED_SUCCESS,
    payload: null,
  };
}

function LoginSuccessAction() {
  return {
    type: LoginManagementActionTypes.LOGIN_SUCCESS,
    payload: null,
  };
}

function LogOutSuccessAction() {
  return {
    type: LoginManagementActionTypes.LOGOUT_SUCCESS,
    payload: null,
  };
}
/// /// Async actions ********************************************************
function CreateOTP(payload, body) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(payload, body, headers);
      dispatch(OTPcreatedSuccessAction());
      dispatch(ApiCallSuccessAction(response));
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
}

function LoginService(payload, body) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(payload, body, headers);
      dispatch(ApiCallSuccessAction(response));
      dispatch(LoginSuccessAction());
      const authToken = response.headers.authorization;
      const userInfo = response.data;
      const userRoles = userInfo.roles.map(role => role.roleName);
      setDataToSessionStorage('authToken', authToken, false);
      setDataToSessionStorage('userInfo', userInfo);
      setDataToSessionStorage('userRoles', userRoles);
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
}

function LogoutAction() {
  return async dispatch => {
    try {
      removeDataFromSessionStorage(null, true);
      dispatch(ResetUIState());
      dispatch(resetFileExplorerStore());
      dispatch(LogOutSuccessAction());
      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  };
}

export {
  LoginManagementActionTypes,
  CreateOTP,
  LoginService,
  LogoutAction,
  OTPcreatedSuccessAction,
  LoginSuccessAction,
};
